import React, { useEffect } from 'react';

const AdSense = ({ layout, slot }) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Adsense error", e);
    }
  }, []);

  return (
    <div>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-format="fluid"
        data-ad-layout-key={layout}
        data-ad-client="ca-pub-6844220659668221"  // replace with your own
        data-ad-slot={slot}      // replace with your own
      ></ins>
    </div>
  );
};

export default AdSense;